import { render, staticRenderFns } from "./marketingShop.vue?vue&type=template&id=7e470d51&scoped=true"
import script from "./marketingShop.vue?vue&type=script&lang=js"
export * from "./marketingShop.vue?vue&type=script&lang=js"
import style0 from "./marketingShop.vue?vue&type=style&index=0&id=7e470d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e470d51",
  null
  
)

export default component.exports